import React from 'react';

interface UserMessageProps {
  content: string;
  isFirst?: boolean;
}

export const UserMessage = React.memo(function UserMessage({
  content,
  isFirst = false
}: UserMessageProps) {
  return (
    <>
    <div className={`flex justify-end flex-wrap`}>
        <div className={`

        ${isFirst 
          ? 'py-3 px-5 rounded-xl max-w-[70%] bg-[#361E06] text-[#ffffff] text-lg'
          : 'py-3 px-5 rounded-xl max-w-[70%] bg-[#361E06] text-[#ffffff] text-lg'
        }
        `}>
          {content}
        </div>
      </div></>
  );
});
